import { gql } from "@apollo/client";

const accountUserFragment = `
fragment accountUserFragment on AccountUser {
  id
  code
  email
  companyName
  role
  companyName
  address
  city
  zip
  province
  country
  vatNumber
  language
  paymentMethod {
    id
    code
    nameEn
    nameIt
  }
}
`;

const accountSessionQuery = `
  accountSession {
    id
    createdAt
    expiredAt
    isPersistent
    remoteIp
    user {
      ...accountUserFragment
    }
    currentUser {
      ...accountUserFragment
      priceList {
        id
        code
        prices {
          id
          itemId
          wholesale
          formattedWholesale
          retail
          formattedRetail
        }
      }
      brands {
        id
        code
        nameEn
        nameIt
        coverHorizontal
        coverVertical
        position
        seasons {
        	id
          code
          nameEn
          nameIt
          kindEn
          kindIt
          isEnabled
          isStock
          shippingWindow
          shippingExpected
          position
        }
      }
    }
  }
`;

const environmentQuery = `
  environment {
    name
  }
`;

const defaultQuery = `
  default {
    language
    timezone
  }
`;

export const getContextQuery = (token: string | undefined) => {
  const validToken = token && token !== "" ? true : false;

  let query = "";
  if (validToken) query += accountUserFragment;
  query += "query {";
  if (validToken) query += accountSessionQuery;
  query += environmentQuery;
  query += defaultQuery;
  query += "}";

  return gql(query);
};
